import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { message, Card, Table, Empty, Divider, Select } from 'antd';

import { Action } from 'fennec-ui'
import { DropdownAction } from 'fennec-ui'
import { GET, errorCatch } from 'fennec-ui'
import "./index.css"

import { createUseStyles } from 'react-jss';
import { MoreOutlined } from '@ant-design/icons';
import AddAdminRo from '../../forms/AddAdminRo';
import { getRregionalnoeOtdelenieFromRoles } from '../../../common/Tool';
import PageLayout from '../../components/PageLayout';
import { useLocaladminContext } from '../../../common/Context';

const { Option } = Select;

const useStyles = createUseStyles({
    collapse: {
        '& .ant-collapse-content > .ant-collapse-content-box': {
            padding: "0px"
        },
        '&.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow': {
            top: "-3px",
            left: "10px"
        },
        '&.ant-collapse > .ant-collapse-item > .ant-collapse-header': {
            padding: "4px 10px",
            paddingLeft: "30px"
        }
    },
    cardSmall: {
        '& .ant-card-body': {
            padding: "0px"
        }
    }
})

export default function LocaladminEventsAdmins(props) {

    const ctx = useLocaladminContext();

    const classes = useStyles()
    const dispatch = useDispatch();
    const { auth, title, size } = props;

    // const regionalnoeOtdelenie = useSelector(getRregionalnoeOtdelenieFromRoles(["АдминистраторОтделения"], true));
    // const [regionalnoeOtdelenie, setRegionalnoeOtdelenie] = React.useState([])
    // React.useEffect(()=>{
    //     GET(auth, '/api/ro/list-by-admin', ({data})=>{
    //         setRegionalnoeOtdelenie(data);
    //     }, errorCatch)
    // }, [])

    const [adminList, setAdminList] = useState([]);

    const sourceKey = "reg";
    const create = true;
    // const context = {
    //     collection: regionalnoeOtdelenie,
    //     name: (item) => item.nazvanie,
    //     mix: (item) => {
    //         return {
    //             // organizatorFederatsiyaID: 1, // Организатор федерация
    //             // organizatorShkolaID: ID, // Организатор школа
    //             // organizatorMeropriyatiyaID: ID, // Организатор мероприятия
    //             organizatorRegionalnoeOtdelenieID: item.ID // Организатор региональное отделение
    //         }
    //     }
    // }

    const [loading, setLoading] = useState(false);

    // const ctx = useSelector(state => state.home.cache[sourceKey]);

    // const [ctx, setCtx] = useState((((context && context.collection) ? context.collection.length : 0) <= 0) ? undefined : (context && context.collection) ? context.collection[0] : undefined);
    // const ctxChange = (value) => {
    //     if (context && context.collection) {
    //         // setCtx(context.collection.find(item => item.ID === value));
    //         dispatch({ type: 'cache', payload: { ...ctx, [sourceKey]: context.collection.find(item => item.ID === value) } });
    //     }
    // };
    // const ctxOptions = (context && context.collection) ? context.collection.map(item => {
    //     return (
    //         <Option value={item.ID} key={item.ID}>{(context.name) ? context.name(item) : ""}</Option>
    //     );
    // }) : undefined;

    useEffect(() => {
        if (ctx) {
            setLoading(true);
            auth.fetch(`/api/ro/admin-event/list/${ctx.ID}`).then(res => {
                setLoading(false);
                if (res && res.data) {
                    setAdminList(res.data);
                }
            }).catch(function (err) {
                setLoading(false);
                message.error("" + err);
            });
        }
    }, [ctx]);

    const admin_delete = (admin) => {
        setLoading(true);
        GET(auth, `/api/delete/ro/admin-event/${admin.ID}`,
            () => {
                setLoading(false);
                var k = [...adminList];
                k.splice(k.findIndex(e => e.ID === admin.ID), 1);
                setAdminList(k);
            },
            (err) => errorCatch(err));
    };
    const columns = () => {
        var c = [];
        c.push({
            title: 'Пользователь',
            render: (text, record) => {
                return (
                    <div>
                        {record.user.lastname + " " + record.user.firstname}
                    </div>
                );
            },
            key: 'user',
        });
        c.push({
            title: 'Email',
            render: (text, record) => {
                return (
                    <div>
                        {record.user.email}
                    </div>
                );
            },
            key: 'email',
        });
        c.push({
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record) => {
                return (
                    <DropdownAction icon={<MoreOutlined />} buttonStyle={{ border: "none" }} items={[
                        {
                            title: "Удалить",
                            mode: "MenuItem",
                            action: () => admin_delete(record)
                        }
                    ]} />
                );
            },
        });

        return c;
    };
    const addAdminRo = (values, unlock, close) => {
        if (!ctx || !ctx.ID) {
            message.error("Необходимо выбрать региональное отделение");
            return
        }
        setLoading(true);
        GET(auth, `/api/add/ro/${ctx.ID}/admin-event/${values.user.ID}`,
            ({ data }) => {
                setLoading(false);
                if (data) {
                    setAdminList([...adminList, data]);
                }
                close();
            },
            (err) => { setLoading(false); errorCatch(err, unlock) });
    };

    const NewElement = () => (
        <Action //{...props}
            mode={"button"}
            auth={auth}
            action={addAdminRo}
            form={AddAdminRo}
            title={"Добавить администратора"}
            modal={{
                // width: "55%",
                minWidth: "400px",
            }}
            readonly={false}
            triggerStyle={{ marginBottom: "5px" }}
            triggerOptions={{
                // type: "primary",
                loading: loading
            }}
        />
    );
    return (
        <PageLayout>
            <div style={{ backgroundColor: "white", borderRadius: "4px" }}>
                <div style={{ padding: "10px" }}>
                    {title || <Divider type="horizontal" orientation="left">
                        Администраторы
                    </Divider>}
                    {create && <>
                        {size !== "small" && <div style={{ paddingBottom: "10px", display: "flex", justifyContent: "flex-end" }}>
                            {/* {(context && context.collection) && <div style={{ width: "100%", paddingRight: "5px" }}>
                                <Select value={(ctx) ? ctx.ID : undefined} style={{ width: "100%" }} onChange={ctxChange}
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }>
                                    {ctxOptions}
                                </Select>
                            </div>} */}
                            {NewElement()}
                        </div>}
                    </>}
                    <Table
                        loading={loading}
                        columns={columns()}
                        pagination={false}
                        dataSource={adminList}
                        locale={{ emptyText: <Empty description={"Нет администраторов"}></Empty> }}
                        size="small"
                        rowKey={(r) => r.ID} />
                </div>
            </div>
        </PageLayout>
    );
}
